import React from 'react';
import { InfoSectionProps } from '../../../../../Sections/HomePage/InfoSection/InfoSection';
import IntroText from '../../../../DefaultTemplate/Components/IntoText/IntroText';
import Container from '../../../../../Common/Container/Container';
import * as classes from './InfoSection.module.scss';
import CircleImage from '../../../../../../assets/images/circle.inline.svg';
import Contacts from '../../../Components/Contacts/Contacts';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import cn from 'classnames';

const InfoSection = ({ aboutText, email, phone }: InfoSectionProps) => {
  const { t } = useTranslation();
  return (
    <section className={classes.wrapper} data-aos='fade-in'>
      <div className={classes.circleWrapper}>
        <CircleImage />
      </div>
      <Container>
        <div className={'row'}>
          <div className={cn('col-md-6', classes.introWrapper)}>
            <div className={classes.introTitle}>{t('homePage.infoSection.introduction')}</div>
            <IntroText introText={aboutText} />
          </div>
          <div className={'col-md-6'}>
            <Contacts phone={phone} email={email} />
          </div>
        </div>
      </Container>
    </section>
  );
};

export default InfoSection;
